import React, { useRef, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import ProjectSections from "../../Data/Projects.json";
import { Link } from "react-router-dom";

function MITMASPortfolio() {
  const [mouseData, setMouseData] = useState({ x: 0, y: 0 });
  const canvasRef = useRef(null);
  const [canvasCTX, setCanvasCTX] = useState(null);
  const [color, setColor] = useState('#333333');
  const [size, setSize] = useState(3);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    setCanvasCTX(ctx);
  }, [canvasRef]);

  const SetPos = (e) => {
    setMouseData({
      x: e.clientX,
      y: e.clientY
    });
    Draw(e);
  };

  const Draw = (e) => {
    const ctx = canvasCTX;
    if (!ctx) return;
    ctx.beginPath();
    ctx.moveTo(mouseData.x, mouseData.y);
    setMouseData({
      x: e.clientX,
      y: e.clientY
    });
    ctx.lineTo(e.clientX, e.clientY);
    ctx.strokeStyle = color;
    ctx.lineWidth = size;
    ctx.lineCap = 'round';
    ctx.stroke();
  };
  // Filter projects relevant to MIT MAS (Media Arts and Sciences)
  // Focus: interactive installations, creative coding, data visualization, 
  // sonification, VR/AR, multimedia, research
  const relevantProjectIds = [
    "confluences-i",          // Confluences - interactive installation
    "livingstatues",          // Living Statues - interactive installation, VR
    "traces",                 // Traces - sonification, creative coding
    "lines",                  // Lines - sonification, creative coding
    "perspectives",           // Perspectives - art, blender, plugin
    "iss",                    // ISS Software Synth - creative coding, data-driven
    "flowers",                // FLOWERS - interactive installation, data visualization
    "birds",                  // BIRDS - interactive installation, data sonification
    "machine-sp-day",         // Through Machine - multimedia, creative coding
    "all-of-us-apples",       // All of Us Apples - video, creative coding, web scraping, data visualization
    "tdsketches",             // Touch Designer Sketches - creative coding
    "vr-maze-builder",        // VR/AR Maze Builder - VR, AR
    "devfest-2023",           // DevFest 2023 - creative direction, design, development
    "iot-mqtt",               // IoT Digital Twinning - research, VR, IoT
    "sidewalk-plants"         // Sidewalk Plants - typology, installation
  ];

  const relevantProjects = relevantProjectIds
    .map(id => ProjectSections.find(project => project.id === id))
    .filter(project => project !== undefined);

  return (
    <>
      <div
        style={{
          mixBlendMode: "multiply",
          display: "block",
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: 9999,
          pointerEvents: 'none',          
        }} 
      >
        <canvas
          ref={canvasRef}
          onMouseEnter={(e) => SetPos(e)}
          onMouseDown={(e) => SetPos(e)}
          onMouseMove={(e) => Draw(e)}
        ></canvas>
      </div>

      <Container 
        fluid 
        className="home-section" 
        id="home"
        onMouseEnter={(e) => SetPos(e)}
        onMouseDown={(e) => SetPos(e)}
        onMouseMove={(e) => Draw(e)}
      >
        <header>
          <nav>
            <ul>
              <li><Link to="/home">Home</Link></li>
              <li className="active-page">(MIT MAS Portfolio)</li>
            </ul>
          </nav>
        </header>

        <main>
          <div style={{ marginBottom: "2rem", padding: "1rem 0" }}>
            <h1 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
              MIT Media Lab Application Portfolio
            </h1>
            {/* <p style={{ fontSize: "1.1rem", lineHeight: "1.6", maxWidth: "800px" }}>
              A curated selection of projects exploring interactive installations, 
              creative coding, data visualization, sonification, and emerging media. 
              These works represent my interests in the intersection of technology, art, 
              and human experience—core themes of the MIT MAS program.
            </p> */}
          </div>
          <p style={{ marginBottom: "2rem" }}>(curated set of projects for my MIT Media Lab application)</p>

          <div className="mitmas-portfolio-grid">
            {relevantProjects.map((project, index) => (
              <Link 
                key={index} 
                to={`/project/${project.id}`}
                className="mitmas-portfolio-card"
              >
                <div className="mitmas-portfolio-thumbnail">
                  <img 
                    src={project.thumbnail} 
                    alt={project.name} 
                    loading="lazy" 
                  />
                </div>
                <div className="mitmas-portfolio-info">
                  <h3 className="mitmas-portfolio-title">{project.name}</h3>
                  <p className="mitmas-portfolio-tags">{project.tags}</p>
                </div>
              </Link>
            ))}
          </div>
        </main>

        <Container>
        </Container>
      </Container>
      <Container fluid>
      </Container>
    </>
  );
}

export default MITMASPortfolio;

